import React, { useState } from 'react';
import { Box, Container, useMediaQuery, CssBaseline, Typography, Alert } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../../styles/theme';
import GoogleSignInButton from '../../components/GoogleSignInButton';
import { GoogleAuthService } from '../../services/GoogleAuthService';
import { router } from '@inertiajs/react';
import BrandingSection from '../../components/BrandingSection';

const AdminLoginPage: React.FC = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const [error, setError] = useState<string | null>(null);

  const handleGoogleResponse = async (response: any) => {
    try {
      await GoogleAuthService.handleGoogleResponseForAdmin(
        response,
        () => router.visit('/admin/'),
        (errorMessage) => setError(errorMessage)
      );
    } catch (error) {
      // Error is already handled by the service
      setError('Authentication failed. Please try again.');
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          backgroundColor: '#FFFA66',
          minHeight: '100vh',
          width: '100vw',
          margin: 0,
          padding: isMobile ? 4 : 3,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: isMobile ? 'flex-start' : 'center',
          boxSizing: 'border-box',
          overflowX: 'hidden'
        }}
      >
        <Container
          maxWidth={false}
          disableGutters={true}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: isMobile ? 'flex-start' : 'center',
            justifyContent: 'center',
            textAlign: isMobile ? 'left' : 'center',
            width: '100%',
            maxWidth: isMobile ? '100%' : '600px',
          }}
        >
          <Alert
            severity="warning"
            sx={{
              mb: 3,
              width: '100%',
              backgroundColor: 'rgba(255, 152, 0, 0.1)',
              '& .MuiAlert-icon': {
                color: '#f57c00'
              }
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
              Admin Access Only
            </Typography>
            <Typography variant="body2">
              This area is restricted to administrators only.
            </Typography>
          </Alert>

          {error && (
            <Alert
              severity="error"
              sx={{
                mb: 3,
                width: '100%'
              }}
              onClose={() => setError(null)}
            >
              {error}
            </Alert>
          )}

          <BrandingSection animatedTaglines={false}>
            <Typography
              variant="h4"
              sx={{
                mb: 3,
                color: '#1a237e',
                fontWeight: 'bold'
              }}
            >
              Admin Portal
            </Typography>
            <GoogleSignInButton
              googleCallback={handleGoogleResponse}
            />
          </BrandingSection>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default AdminLoginPage;